// extracted by mini-css-extract-plugin
export default {"section":"ServiceSection_section__DX+ni","content":"ServiceSection_content__T2h8E","description":"ServiceSection_description__acui4"};